import { FORM_KEYS } from 'shared/constant/index';

const {
  ID_PASSPORT,
  CLIENT_DETAILS, PEP, BANK, SOURCE_OF_WEALTH, ASI, CLIENT_PROFILE_FORM,
  FATCA, CRS,
  COUNTRY_TAX,
  // APPLICANT,
} = FORM_KEYS;

const dataWithSkipIds = {
  // applicantRootReducer: {
  // applicantReducer: {
  //   [APPLICANT.APPLICANT_ID]: 63,
  //   [APPLICANT.PHONE_NUMBER]: '+6582003477',
  //   [APPLICANT.IS_EMAIL_SENT]: null,
  //   imarkazRefCode: null,
  //   completionDate: null,
  //   lastLoggedIn: null,
  //   currentLoggedIn: null,
  //   latestRefCode: 'IS_LOGOUT',
  // },
  idPassportReducer: {
    [ID_PASSPORT.FULL_NAME]: 'James Deakin',
    [ID_PASSPORT.CIVIL_ID]: '113456789012',
    [ID_PASSPORT.SELFIE]: '',
    [ID_PASSPORT.CIVIL_ID_FRONT]: '',
    [ID_PASSPORT.CIVIL_ID_BACK]: '',
    [ID_PASSPORT.PASSPORT]: '',
    [ID_PASSPORT.TO_BE_EMAILED]: '',
  },
  personalInformationReducer: {
    clientDetails: {
      [CLIENT_DETAILS.CLIENT_CLASSIFICATION]: 'NW-MAR-CLA-QUA',
      [CLIENT_DETAILS.QUALIFIED_INVESTOR]: ['NW-MAR-CLA-QUA-TWO', 'NW-MAR-CLA-QUA-THREE'],
      [CLIENT_DETAILS.TYPE_OF_INVESTMENT]: 'NW-MAR-CLA-NDIS', // Non discretionary
      [CLIENT_DETAILS.PRODUCT]: '',
      [CLIENT_DETAILS.NATIONALITY]: 'Kuwaiti',
      [CLIENT_DETAILS.DATE_OF_BIRTH]: '10101980',
      [CLIENT_DETAILS.CITY_OF_BIRTH]: 'Kuwait City',
      [CLIENT_DETAILS.COUNTRY_OF_BIRTH]: 'Kuwait',
      [CLIENT_DETAILS.OCCUPATION]: 'Lorem ipsum occupation',
      [CLIENT_DETAILS.HOME_ADDRESS]: '100 Lorem Street, Kuwait',
      [CLIENT_DETAILS.COUNTRY_OF_RESIDENCE]: 'Kuwait',
      [CLIENT_DETAILS.EMAIL_ADDRESS]: 'urico.mondelo@newwealth.com.sg',
      [CLIENT_DETAILS.MOBILE]: '+6582003477',
      [CLIENT_DETAILS.EMPLOYER_BUSINESS_NAME]: 'New Wealth',
      [CLIENT_DETAILS.POSITION]: 'Senior Lorem ipsum',
      [CLIENT_DETAILS.OFFICE_ADDRESS]: '100 Telok Ayer',
      [CLIENT_DETAILS.INVESTMENT_STRATEGY]: [],
      [CLIENT_DETAILS.INVESTED_AMOUNT]: '',
      [CLIENT_DETAILS.INVESTED_UNIT_TO_AMOUNT]: '',
      [CLIENT_DETAILS.BUFFERED_INVESTMENT_UNITS]: '',
      [CLIENT_DETAILS.INVESTMENT_UNIT_TYPE]: '',
      [CLIENT_DETAILS.INVESTMENT_UNITS]: '',
      [CLIENT_DETAILS.ARABIC_FUND_NAME]: '',
      assetAllocations: 'NW-MAR-CLA-AA-MAR',
    },
    pep: {
      [PEP.IS_PEP]: 'No',
      [PEP.BENEFICIARIES]: [{
        id: 'pep-1',
        [PEP.NAME]: '',
        [PEP.CURRENT_FORMER_OPTION]: 'Current',
        [PEP.POSITION]: '',
        [PEP.RELATIONSHIP]: '',
      }],
    },
    bankDetails: {
      [BANK.BANK_NAME]: 'NW-MAR-BANK-COM',
      [BANK.OTHER_BANK_NAME]: '',
      [BANK.DOMICILE_COUNTRY]: '',
      [BANK.ACCOUNT_NAME]: 'James Deakin',
      [BANK.IBAN]: 'BE68539007547034',
      [BANK.CURRENCY]: 'NW-MAR-CUR-KWD',
    },
    sourceOfWealth: {
      [SOURCE_OF_WEALTH.ESTIMATED_WEALTH]: 'NW-MAR-ESW-TWO',
      [SOURCE_OF_WEALTH.WEALTH_FUNDS]: 'NW-MAR-SOW-INV',
      [SOURCE_OF_WEALTH.OTHER_SOURCE_OF_WEALTH]: '',
      // [SOURCE_OF_WEALTH.NET_ASSETS]: '',
      [SOURCE_OF_WEALTH.NET_INCOME]: 'NW-MAR-NI-TWO',
    },
    asi: {
      [ASI.IS_AUTHORITY_TO_DEAL]: '',
      [ASI.POA_HOLDER]: 'No',
      [ASI.NAME]: '',
      [ASI.ADDRESS]: '',
      [ASI.EMAIL_ADDRESS]: '',
      [ASI.NATIONALITY]: '',
      [ASI.DOB]: '',
      [ASI.OCCUPATION]: '',
      [ASI.POSITION]: '',
      [ASI.MOBILE]: '',
      [ASI.EMPLOYER_BUSINESS_NAME]: '',
      [ASI.RELATIONSHIP_WITH_CLIENT]: '',
      [ASI.IS_AS_US_PERSON]: '',
    },
    clientProfileForm: {
      [CLIENT_PROFILE_FORM.GOAL]: '',
      [CLIENT_PROFILE_FORM.INVESTMENT_PURPOSE]: '',
      [CLIENT_PROFILE_FORM.INVESTMENT_PURPOSE_OTHERS]: '',
      [CLIENT_PROFILE_FORM.RISK_TOLERANCE]: '',
      [CLIENT_PROFILE_FORM.INVESTMENT_EXP_BONDS_YRS]: '',
      [CLIENT_PROFILE_FORM.INVESTMENT_EXP_BONDS_STRATEGY]: '',
      [CLIENT_PROFILE_FORM.INVESTMENT_EXP_EQUITIES_YRS]: '',
      [CLIENT_PROFILE_FORM.INVESTMENT_EXP_EQUITIES_STRATEGY]: '',
      // [CLIENT_PROFILE_FORM.INVESTMENT_EXP_DERIVATIVES_YRS]: '',
      // [CLIENT_PROFILE_FORM.INVESTMENT_EXP_DERIVATIVES_STRATEGY]: '',
      [CLIENT_PROFILE_FORM.INVESTMENT_EXP_PRIVATE_EQUITY_HEDGE_FUNDS_YRS]: '',
      [CLIENT_PROFILE_FORM.INVESTMENT_EXP_PRIVATE_EQUITY_HEDGE_FUNDS_STRATEGY]: '',
      [CLIENT_PROFILE_FORM.INVESTMENT_EXP_REAL_ESTATE_YRS]: '',
      [CLIENT_PROFILE_FORM.INVESTMENT_EXP_REAL_ESTATE_STRATEGY]: '',
      [CLIENT_PROFILE_FORM.INVESTMENT_EXP_OTHER_ALTERNATIVE_YRS]: '',
      [CLIENT_PROFILE_FORM.INVESTMENT_EXP_OTHER_ALTERNATIVE_STRATEGY]: '',
      [CLIENT_PROFILE_FORM.INDEPENDENT_PROF_ADVICE]: '',
      [CLIENT_PROFILE_FORM.INSIDER_STATUS]: '',
      [CLIENT_PROFILE_FORM.INSIDER_STATUS_LIST]: [{
        id: 'insiderForm-1',
        [CLIENT_PROFILE_FORM.INSIDER_STATUS_LIST_COMPANY]: '',
        [CLIENT_PROFILE_FORM.INSIDER_STATUS_LIST_POSITION]: '',
      }],
      [CLIENT_PROFILE_FORM.INVESTMENT_OBJECTIVE_TIME_HORIZON]: '',
      [CLIENT_PROFILE_FORM.ASSET_CLASSES]: [],
      [CLIENT_PROFILE_FORM.MARKETS]: [],
      [CLIENT_PROFILE_FORM.INVESTMENT_KNOWLEDGE]: '',
      [CLIENT_PROFILE_FORM.RESTRICTIONS]: '',
      // [CLIENT_PROFILE_FORM.OTHER_SECTOR]: '',
      // [CLIENT_PROFILE_FORM.OTHER_ISSUER]: '',
      [CLIENT_PROFILE_FORM.OTHER_RESTRICTION]: '',
    },
  },
  fatcaCrsReducer: {
    fatca: {
      [FATCA.FATCA_Q1]: 'Yes',
      [FATCA.FATCA_Q2]: '',
      [`${FATCA.FATCA_Q2}${FATCA.STATE}`]: '',
      [`${FATCA.FATCA_Q2}${FATCA.CITY}`]: '',
      [FATCA.FATCA_Q3]: '',
      [`${FATCA.FATCA_Q3}${FATCA.ADDRESS}`]: '',
      [`${FATCA.FATCA_Q3}${FATCA.US_PHONE}`]: '',
      [FATCA.FATCA_Q4]: '',
      [`${FATCA.FATCA_Q4}${FATCA.ADDRESS}`]: '',
      [FATCA.FATCA_Q5]: '',
      [`${FATCA.FATCA_Q5}${FATCA.BENEFICIARY}`]: '',
      [`${FATCA.FATCA_Q5}${FATCA.NATIONALITY}`]: '',
      [FATCA.FATCA_Q6]: '',
      [`${FATCA.FATCA_Q6}${FATCA.NAME_OF_PERSON}`]: '',
      [`${FATCA.FATCA_Q6}${FATCA.NATIONALITY}`]: '',
      [`${FATCA.FATCA_Q6}${FATCA.ADDRESS}`]: '',
      [`${FATCA.FATCA_Q6}${FATCA.US_PHONE}`]: '',
    },
    crs: {
      [CRS.CRS_Q1]: 'No',
      [CRS.RESIDENT_REPORTABLE_JURISDICTION]: '',
      [CRS.CRS_Q2]: 'No',
      [CRS.RESIDENCE_ADDRESS]: '',
      [CRS.CRS_Q3]: 'No',
      [CRS.TELEPHONE_NUMBER]: '',
      [CRS.CRS_Q4]: 'No',
      [CRS.HOLD_MAIL]: '',
      [CRS.CRS_Q5]: 'No',
      [CRS.STANDING_INSTRUCTION]: '',
      [CRS.CRS_Q6]: 'No',
      [CRS.EFFECTIVE_POA]: '',
    },
    countryTax: [{
      id: 'tax-1',
      [COUNTRY_TAX.COUNTRY_JURISDICTION]: 'Kuwait',
      [COUNTRY_TAX.IS_TIN]: 'Yes',
      [COUNTRY_TAX.TIN]: '113456789012',
      [COUNTRY_TAX.REASON_OPTION]: '',
      [COUNTRY_TAX.REASON_TIN_NOT_ISSUED]: '',
    }],
  },
  // },
};

const savedStates = {
  dataWithSkipIds,
};

export default savedStates;
